import { collab } from '@/utils'

import { Response, Service } from '.'

const fetch = async (): Promise<Response> => {
  try {
    const res = await collab.get<Response>('customer/profile')
    return res.data
  } catch (e) {
    throw e
  }
}

export const service: Service = {
  fetch
}
